import { CertificationItem, Study } from '@mitsubishi/shared/data-access';

import { EditProjectCompaniesRequest, Project, ProjectDetails, ProjectLoadOptions } from '../../models';

abstract class BaseProjectAction {
  constructor(public projectId: string) {}
}

export namespace ProjectActions {
  export class Load extends BaseProjectAction {
    static readonly type = '[Project] Load Project Details';
    constructor(
      projectId: string,
      public readonly options?: ProjectLoadOptions
    ) {
      super(projectId);
    }
  }

  export class LoadSuccess {
    static readonly type = '[Project] Load Project Success';
    constructor(public project: Project) {}
  }

  export class UpdateProjectTitle {
    static readonly type = '[Project - API] Update Project';
    constructor(
      public projectId: string,
      public title: string
    ) {}
  }

  export class Set {
    static readonly type = '[Project - API] Set Project';
    constructor(public project: Project) {}
  }

  export class AddStudy {
    static readonly type = '[Project] Add study';
    constructor(public study: Study) {}
  }

  export class UpdateState {
    static readonly type = '[Project] Update Project State';
    constructor(public projectDetails: Partial<ProjectDetails>) {}
  }

  export class Delete extends BaseProjectAction {
    static readonly type = '[Project] Delete';
  }

  export class DeleteSuccess {
    static readonly type = '[Project] Delete success';
  }

  export class Activate extends BaseProjectAction {
    static readonly type = '[Project] Activate';
  }

  export class Archive extends BaseProjectAction {
    static readonly type = '[Project] Archive';
  }

  export class Restore extends BaseProjectAction {
    static readonly type = '[Project] Restore';
  }

  export class AddFavorite extends BaseProjectAction {
    static readonly type = '[Project] Add to favorite';
  }

  export class RemoveFavorite extends BaseProjectAction {
    static readonly type = '[Project] Remove from favorite';
  }

  export class Duplicate extends BaseProjectAction {
    static readonly type = '[Project] Duplicate';
    constructor(
      projectId: string,
      public requestTraceId?: string
    ) {
      super(projectId);
    }
  }

  export class EditProjectCompanies {
    static readonly type = '[Porject] Edit projects companies';
    constructor(
      public projectId: string,
      public request: EditProjectCompaniesRequest
    ) {}
  }

  export class Reset {
    static readonly type = '[Project] Reset state';
  }

  export class UpdateCertification {
    static readonly type = '[Project - API] Update Certification';
    constructor(
      public projectId: string,
      public certification: CertificationItem[]
    ) {}
  }
  export class UpdateUnitsOfMisures {
    static readonly type = '[Project - API] Update Units Of Misures';
    constructor(
      public projectId: string,
      public uom: any
    ) {}
  }
}
